import { render, staticRenderFns } from "./outline.vue?vue&type=template&id=48528a1a"
import script from "./outline.vue?vue&type=script&lang=js"
export * from "./outline.vue?vue&type=script&lang=js"
import style0 from "./outline.vue?vue&type=style&index=0&id=48528a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports